import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnCL: CultureInfo = {
  name: 'en-CL',
  displayName: 'English (Chile)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-CL',
  parent: CultureInfoEn
};
